import { useSiteCapabilityCheck } from './use-site-capability-check';

type HardwareConfigurationType = 'default' | 'sense' | 'ayla' | 'evse' | 'none';

export function useSiteHardwareConfigurationType(): {
  hardwareConfigurationType: HardwareConfigurationType;
  isLoading: boolean;
} {
  const { siteHasMeter, siteHasInverter, siteHasEvCharger, siteHasAylaSwitches, isLoading } = useSiteCapabilityCheck();

  let hardwareConfigurationType: HardwareConfigurationType = 'none';

  if (siteHasMeter && !siteHasInverter) {
    hardwareConfigurationType = 'sense';
  } else if (siteHasInverter) {
    hardwareConfigurationType = 'default';
  } else if (siteHasAylaSwitches) {
    hardwareConfigurationType = 'ayla';
  } else if (siteHasEvCharger) {
    hardwareConfigurationType = 'evse';
  }

  return {
    hardwareConfigurationType,
    isLoading,
  };
}
